// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__wQBrT","header":"Messages_header__1i6vB"};